export enum ReportsTimePeriod {
  LAST_WEEK = "Last week",
  LAST_MONTH = "Last month",
}
